'use strict';
import React from 'react';
import { Layout } from '../layouts/layout/layout';
import { HomepageWithPanelHome } from '../../views/home/home-page-panels';

class Homepage extends React.Component {
    render() {
        return (
            <Layout
                mainContainerProps={{ id: 'homepage-list' }}
                user={this.props.user}
                categories={this.props.categories}
                panels={this.props.panels}
            >
                <HomepageWithPanelHome
                    panels={this.props.panels}
                    collapsableCategories={this.props.collapsableCategories}
                    categories={this.props.categories}
                    layoutItemCount={this.props.layoutItemCount}
                    user={this.props.user}
                    numberOfCategories={this.props.numberOfCategories}
                />
            </Layout>
        );
    }
}

export default Homepage;
